import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '../core/modules/shared.module';

import { FuseMainComponent } from './main.component';

import { FuseContentComponent } from './content/content.component';
import { FuseNavigationModule } from '../core/components/navigation/navigation.module';
import { FuseThemeOptionsComponent } from '../core/components/theme-options/theme-options.component';
import { FuseShortcutsModule } from '../core/components/shortcuts/shortcuts.module';
import { FuseSearchBarModule } from '../core/components/search-bar/search-bar.module';

@NgModule({
    declarations: [
        // FuseLoginComponent,
        FuseContentComponent,
        FuseMainComponent,
        FuseThemeOptionsComponent,

    ],
    imports: [
        SharedModule,
        RouterModule,
        FuseNavigationModule,
        FuseShortcutsModule,
        FuseSearchBarModule,        
    ],
    exports: [
        FuseMainComponent
    ]
})

export class FuseMainModule {
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/main.module.ts